<h3 class="titulo">{{'TRAMITES.DISPONIBLES'|translate}}</h3>
  <div class="p-grid p-jc-between main-tramites">
    <div class="p-sm-12 p-lg-4">
      <p-panel styleClass="p-d-flex p-flex-column" header="Trámites sin registro">
        <div *ngFor="let tramite of tramites1">
          <li>
            <a [href]="tramite.url" *ngIf="tramite.url !== ''">{{ tramite.name |translate}}</a>
            <span *ngIf="tramite.url === ''">{{ tramite.name |translate}}</span>
          </li>
        </div>
      </p-panel>
    </div>
    <div class="p-sm-12 p-lg-4 ">
      <p-panel styleClass="p-d-flex p-flex-column" header="Trámites con registro desde app móvil">
        <div *ngFor="let tramite of tramites2">
          <li>
            <a [href]="tramite.url" *ngIf="tramite.url !== ''">{{ tramite.name |translate}}</a>
            <span *ngIf="tramite.url === ''">{{ tramite.name |translate}}</span>
          </li>
        </div>
      </p-panel>
    </div>  
    <div class="p-sm-12 p-lg-4">
      <p-panel styleClass="p-d-flex p-flex-column" header="Trámites con registro desde app móvil o web">
        <div *ngFor="let tramite of tramites3">
          <li>
            <a [href]="tramite.url" *ngIf="tramite.url !== ''">{{ tramite.name |translate}}</a>
            <span *ngIf="tramite.url === ''">{{ tramite.name |translate}}</span>
          </li>
        </div>
      </p-panel>
    </div>
  </div>


